module.exports = {
  challenging_questions: {
    title: 'Hardest questions of the week',
    failrate: '%{failrate}% were wrong',
    answered_correctly: 'You answered this question correctly',
    test_my_knowledge: 'Would you have known?',
  },
  rank: 'Rank',
  wins: 'Wins',
  by_wins: 'by wins',
  answers: 'Answers',
  answers_correct_percentage: '%{percentage}% correct',
  win_percentage: '%{percentage}% won',
  correct_answers_14_days: 'Correct answers in last 14 days',
  correct_answers: '%{answers} correct answer | %{answers} correct answers',
  answers_by_category: 'Answers by category',
}
